// src/hooks/useApiOnRouteChange.ts
import { useEffect , useContext } from "react";
import { useLocation } from "react-router-dom";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { CURRENT_CLIENT_VERSION } from "./appVersion";
import { RolePermissions, PermissionContext } from "../appContext";
import { pages } from "../views/pages/manage/common/constant";

export const useApiOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    const callApi = async () => {
      try {
        const data = await fetchAllPromisedData(endpoint.uiVersion);
        const currentVersionOnClient = CURRENT_CLIENT_VERSION;
        if (data && data?.uiVersionInfo && currentVersionOnClient) {
          const currentVersionFromServer = data.uiVersionInfo;
           if (currentVersionFromServer !== currentVersionOnClient){
               window.location.reload();
              }
        }
      } catch (error) {
        console.error("Failed to call API on route change:", error);
      }
    };

    callApi();
  }, [location.pathname]); // Call API when URL (pathname) changes
};

export const useGetPermissions = (screen) => RolePermissions(useContext(PermissionContext) , pages[screen]?.["id"]);


